import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setStepperState } from '../../features/stepper/stepperSlice';
import { Box, Fade, Rating, Typography } from '@mui/material';
import { CustomContainer } from '../../components/CustomContainer';
import { StepperCard } from '../../components/StepperComponent';
import { colors } from '../../styles/colors';
import FindHolidayWidget from '../../components/FindHolidayWidget';
import { setIsClickedFilters, setIsHolidayApiCall, setPosition, setShowPopup } from '../../features/commonState';
import { getLocalStorage, getSessionStorage } from '../../helpers/storage';
import { useAppSelector } from '../../hooks/useAppReducer';
import { useLocation } from 'react-router-dom';
import useWindowWidth from '../../hooks/useWindowWidth';
import Image from "../../components/Image";
import { ReactComponent as RightChevron } from "../../assets/icons/RightChervon.svg";
import dayjs from "dayjs";
import StarIcon from "@mui/icons-material/Star";
import ReturnToOffer from '../../components/ReturnToOffer';
import { getCookie } from '../../helpers/cookieUtils';
const Search = () => {
    let existingData: any[] = [];
    const cookieData = getCookie("sharedCookieData");
    if (cookieData) {
        try {
            const parsed = JSON.parse(decodeURIComponent(cookieData));
            existingData = Array.isArray(parsed) ? parsed : [parsed];
        } catch (e) {
            existingData = [];
        }
    }
    // const popupData = JSON.parse(getLocalStorage("searchCriteria") || "{}");
    const hasPopupData = existingData && Object.keys(existingData).length > 0;
    const { storePayload, showPopup } = useSelector((state: any) => state.commonState);
    const windowWidth = useWindowWidth()
    const dispatch = useDispatch();


    const { holidayPackage, filteredHolidayPackage } = useAppSelector((state) => state.holidayPackage);

    useEffect(() => {
        dispatch(setShowPopup(hasPopupData))
        dispatch(setStepperState(0));
    }, [dispatch]);

    const getPosition = (data?: any, isButtonClicked?: boolean, filterApply?: any) => { }


    useEffect(() => {
        if (window.innerWidth < 1024) {
            if (getSessionStorage("click") === "false") {
                getPosition(filteredHolidayPackage, false, true)
            }
        }
    }, [window.innerWidth, filteredHolidayPackage, getSessionStorage("click")])
    return (
        <Box position='relative' bgcolor={colors.basics.secondary}>
            <Box
                // mb={{ xs: '16px' }}
                pt={{ xs: windowWidth < 376 ? '44px' : '60px', sm: '0' }}
            >
            </Box>
            <Box>
                <CustomContainer style={{ maxWidth: '1368px !important' }}>

                    {/* <StepperCard /> */}
                    <Typography variant='body1' fontSize='16px' fontWeight={400} lineHeight='130%' py='16px' >
                        Home
                    </Typography>

                </CustomContainer>
                <Box bgcolor={colors.grey[20]} sx={{
                    // mt: { xs: '16px' },
                    pb: { md: '35px', xs: '20px' },
                    pt: { md: '35px', xs: '20px' },
                    '& .MuiContainer-maxWidthLg ': {
                        maxWidth: '1368px !important',
                        padding: '0 16px !important'
                    }
                    // position: 'sticky !important',
                    // top: '116px !important'
                }}>
                    <CustomContainer style={{ maxWidth: '1368px !important', padding: { sm: "0 20px !important", xs: '0 10px !important' } }}>
                        <Box>
                            {/* <Typography variant='h1' fontSize='28px' fontWeight={600} lineHeight='44px' mb='15px'>
                                Find your perfect holiday
                            </Typography> */}
                            {/* {window.location.host.includes("localhost") && <h2 style={{ marginBottom: "10px" }}> Search date after 4 months</h2>} */}
                            <FindHolidayWidget
                                setIsHolidayApiCall={setIsHolidayApiCall}
                                setIsClickedFilters={setIsClickedFilters}
                                getPosition={getPosition}
                            />
                        </Box>
                    </CustomContainer>
                </Box>
                {
                    (holidayPackage?.Packages?.results?.length == 0 || storePayload == undefined) ? (
                        <>
                            <Typography variant='h1' pt={{
                                sm: '80px', xs: 6
                            }} textAlign='center' color={colors.grey[40]} >
                                Unfortunately, no results were returned for the package you have searched.
                            </Typography>
                            <Typography variant='h1' pb={{
                                sm: "40px", xs: "20px"
                            }} textAlign='center' color={colors.grey[40]} >
                                Please search again for alternatives.
                            </Typography>
                        </>)
                        : <Typography pt={{ xs: 6, sm: '80px' }} pb={{ xs: 6, sm: '40px' }}
                            mx={{ xs: 2, sm: '0' }}
                            // marginTop={{
                            //   sm: 0, xs: "20px"
                            // }}
                            variant='h1' textAlign='center' color={colors.grey[40]} >
                            Please complete the form above to explore our range of holidays.
                        </Typography>
                }
                {/* <Box >
                    {showPopup &&(
                        <ReturnToOffer />
                    )}
                </Box> */}

                {/* <HotelComponent /> */}
            </Box>
        </Box >
    )
}

export default Search